import React from "react";

export function QuarterlyPricesDisclaimer() {
  return <p style={{backgroundColor: "mistyrose", padding: "1em"}}>
    Den första oktober infördes <a
    href="https://ei.se/bransch/ellagens-kundnara-bestammelser/fragor-och-svar-om-overgangen-till-kvartspris">kvartsmätning
    av el</a> i EU. Stödet för kvartspriser på den här sidan är inte komplett ännu så de faktiska priserna kan skilja
    sig både upp och ner jämfört med de som visas. Sidan kommer uppdateras inom kort.
  </p>;
}
